module.exports = __webpack_public_path__ + "img/iconweibiaoji.6264d5b6.png";